import {
  ThumbUpAltOutlined as ThumbUpAltOutlinedIcon,
  ThumbDownAltOutlined as ThumbDownAltOutlinedIcon,
} from '@mui/icons-material';
import { useMemo } from 'react';

import type { AnswerProps } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/components/Answer/types';

export const useGivenFeedback = (isAnswerLiked: AnswerProps['isAnswerLiked']) =>
  useMemo(() => {
    if (typeof isAnswerLiked !== 'boolean') {
      return null;
    }

    return isAnswerLiked ? (
      <ThumbUpAltOutlinedIcon color="disabled" />
    ) : (
      <ThumbDownAltOutlinedIcon color="disabled" />
    );
  }, [isAnswerLiked]);
